/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
} from './Link';

/**
 * 
 * @export
 * @interface OrgParent
 */
export interface OrgParent {
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof OrgParent
     */
    links?: { [key: string]: Link; };
}

/**
 * Check if a given object implements the OrgParent interface.
 */
export function instanceOfOrgParent(value: object): boolean {
    return true;
}

export function OrgParentFromJSON(json: any): OrgParent {
    return OrgParentFromJSONTyped(json, false);
}

export function OrgParentFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgParent {
    if (json == null) {
        return json;
    }
    return {
        
        'links': json['links'] == null ? undefined : (mapValues(json['links'], LinkFromJSON)),
    };
}

export function OrgParentToJSON(value?: OrgParent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'links': value['links'] == null ? undefined : (mapValues(value['links'], LinkToJSON)),
    };
}

